<div [class.ghost]="routeRecommendationTask == null">
  <div class="">
    <div class="">
      <job-screen-location
        [location]="routeRecommendationTask.pickupLocation"
        [earliestTime]="routeRecommendationTask.pickupEarliestDateTime"
        [latestTime]="routeRecommendationTask.pickupLatestDateTime"
        [IsPickup]="true"
      >
      </job-screen-location>
      <job-screen-location
        [location]="routeRecommendationTask.dropoffLocation"
        [earliestTime]="routeRecommendationTask.dropoffEarliestDateTime"
        [latestTime]="routeRecommendationTask.dropoffLatestDateTime"
        [IsPickup]="false"
      >
      </job-screen-location>
    </div>
  </div>
</div>
